import { AreaChartCard } from 'componets/ui';

import { getPrincipalRepayment } from 'features/statement/actions';

import { useAppSelector, useTranslate } from 'hooks';

import Utils from 'utils/utils';

export const PrincipalRepayment = () => {
	const principalRepayment = useAppSelector((state) => state.statement.principalRepayment);

	const { principalRepaymentText } = useTranslate(['principalRepaymentText']);

	return (
		<AreaChartCard
			subtitle={Utils.moneyFormat(+principalRepayment.total)}
			data={principalRepayment.items}
			getData={getPrincipalRepayment}
			title={principalRepaymentText}
		/>
	);
};
